import React from "react";
import { Shop } from "../components/Shop/Shop";
import { Page } from "../components/Page/Page";
import "./PageLayout.css";

export function ShopPage() {
  return (
    <Page>
      <div className="page-layout page-layout--animated">
        <div className="page-content">
          <Shop />
        </div>
      </div>
    </Page>
  );
}
